import { GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateTruckForSalePopup from "../../../components/Sales/UpdateTruckForSalePopup/UpdateTruckForSalePopup";

export function getTrucksForSaleTableColumns(
  openUploadModal: (row: any) => void,
  openPreviewModal: (row: any) => void
): GridColDef[] {
  return [
    {field: "unitNumber", headerName: "Unit Number", width: 150},
    { field: "make", headerName: "Make", width: 300 },
    { field: "model", headerName: "Model", width: 250 },
    { field: "vin", headerName: "VIN", width: 300 },
    { field: "year", headerName: "Year", width: 100 },
    { field: "engineType", headerName: "Engine Type", width: 200 },
    { field: "location", headerName: "Location", width: 200 },
    { field: "transmission", headerName: "Transmission", width: 200 },
    { field: "suspension", headerName: "Suspension", width: 200 },
    { field: "drive", headerName: "Drive", width: 200 },
    { field: "axleRatio", headerName: "Axle Ratio", width: 200 },
    { field: "wheelbase", headerName: "Wheel Base", width: 200 },
    { field: "brakes", headerName: "Brakes", width: 200 },
    { field: "sleeper", headerName: "Sleeper", width: 200 },
    { field: "mileage", headerName: "Mileage", width: 150 },
    { field: "price", headerName: "Price", width: 150 },
    { field: "isTruckFeatured", headerName: "Featured", width: 150 },
    { field: "isActive", headerName: "Status", width: 150 },
    {
      field: "update",
      headerName: "Update",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return <UpdateTruckForSalePopup truckForSale={params.row} />;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;
        return (
          <>
            <Button
              variant="contained"
              size="small"
              onClick={() => openUploadModal(row)}
            >
              Upload Images
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => openPreviewModal(row)}
              style={{ marginLeft: 8 }}
            >
              Preview
            </Button>
          </>
        );
      },
    },
    {
      field: "Delete",
      headerName: "Delete",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        return (
          <ConfirmActionButton
            id={params.row.id}
            entityType="TruckSaleImages"
            actionType="delete"
            entityLabel="Truck's Images"
            queryKey="trucksForSale"
            buttonLabel="Delete all images"
            buttonColor="error"
          />
        );
      },
    },
  ];
}
